import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "Utils/LoadMask/LoadMask";
import SegmentedControl from "Utils/Utils/SegmentedControl";
import { FiltrosReporteProduccion } from "../../components/FiltrosReporteProduccion";
import { useReporteCierresMensuales } from "../../ReporteCierresMensuales/hooks/useReporteCierresMensuales";
import { GraficaVariacionCierres } from "../../ReporteCierresMensuales/components/GraficaVariacionCierres";
import { GraficaMonetariaCierres } from "../../ReporteCierresMensuales/components/GraficaMonetariaCierres";
import { ReporteCierresMensualesTable } from "../../ReporteCierresMensuales/components/ReporteCierresMensualesTable";
import { OPCIONES_TIPO_REPORTE } from "../../ReporteCierresMensuales/helpers/tiposReporteCierres";
import "../../ReporteCierresMensuales/styles/ReporteCierresMensuales.css";

// Kg secos enviados a producción contra la producción obtenida en cada cierre
// mensual registrado del padre PT, según laboratorio o según liquidación. Las
// gráficas comparan las dos versiones, la de variación también con tolva, por
// eso el tipo se elige junto a la tabla
export const ReporteCierresMensualesTab = () => {
    const hook = useReporteCierresMensuales();

    return (
        <div className="reportes-produccion__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={hook.cargando} blur>
                    <div className="reportes-produccion__table-header">
                        <FiltrosReporteProduccion hook={hook} />

                        <div
                            className="formulario-field mb-0 no-flex"
                            style={{ maxHeight: "51px" }}
                        >
                            <button
                                className="btn btn-secondary mt-auto text-nowrap"
                                onClick={hook.descargarExcel}
                                disabled={hook.cargando}
                            >
                                Exportar a Excel
                            </button>
                        </div>
                    </div>

                    <GraficaVariacionCierres hook={hook} />
                    <GraficaMonetariaCierres hook={hook} />

                    <div className="reporte-cierres-mensuales__tipo">
                        <SegmentedControl
                            options={OPCIONES_TIPO_REPORTE}
                            value={hook.tipo}
                            onChange={hook.cambiarTipo}
                        />
                    </div>

                    <ReporteCierresMensualesTable hook={hook} />
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
